import { FC, memo } from "react";
import { HeadingIcon, PackageName } from "#/molecules";

import { Card } from "#/atoms";
import { DESKTOP_SPACING } from "@/theme";
import { PackageCardProps } from "./Package.interface";

const PackageCard: FC<PackageCardProps> = ({order }) => {
  return (
    <Card>
      <HeadingIcon
        icon="orders"
        mb={`${DESKTOP_SPACING.XXXL}px`}
        title="Package"
      />
      <PackageName icons={[]} id={order.id} name={order.description.substring(0, order.description.indexOf('/'))} />
    </Card>
  );
};

export default memo(PackageCard);